<script>
    export let title = "InCA WhichOneIs";
</script>

<header>
    <h1 align="CENTER">{title}</h1>
</header>

<style>
    h1 {
        font-size: min(15vh, 11vw);
    }
</style>
